export default {
  slots: {
    root: 'space-y-4 pb-2',
    item: 'border last:border-b rounded-lg shadow shadow-gray-200/50 overflow-hidden',
    trigger: 'mb-0 cursor-pointer sm:text-lg text-base text-left font-bold px-4 hover:bg-gray-50 transition-colors duration-200',
  },
}